export function makeLogger(prefix: string) {
	const key = `[${prefix}]`;
	return {
		debug: (...args: any[]) => {
			console.debug(key, ...args);
		},
	};
}
